module.exports = __webpack_public_path__ + "static/media/no-result-for-search.63876499.svg";